import { useTranslation } from 'react-i18next'
import { VpIcon, VpProgressBar } from '@vtmn-play/react'
import { useFormatNumber } from 'core/hooks/useFormatNumber'
import { VtmnTooltip } from '@vtmn/react'
import type { ReactElement } from 'react'
import WidgetErrorCard from '../../../../components/common/cards/widget-error-card'

interface CircularProgressBarProps {
  hasRealized?: boolean
  hasForecasted?: boolean
  percentage?: number
  label?: string
  errorMessage?: string
  tooltipMessage?: string
  valueText?: ReactElement<any, any>
  src?: string
  className?: string
}

const CircularProgressBar = ({
  hasRealized,
  hasForecasted,
  percentage,
  label,
  errorMessage,
  tooltipMessage,
  valueText,
  src,
  className
}: CircularProgressBarProps) => {
  const { t } = useTranslation()
  const formatNumber = useFormatNumber()

  if (hasRealized && hasForecasted) {
    return (
      <div className="progress-element-container">
        <VpProgressBar
          value={percentage}
          variant="circular"
          size="small"
          // @ts-expect-error
          valueText={valueText}
          src={src}
          className={className}
        />
        <div className="progress-value-container">
          <div className="vp-subtitle-l progress-value-text">
            {formatNumber(percentage / 100, '-', {
              style: 'percent',
              maximumFractionDigits: 1
            })}
          </div>
          <div className="progress-description-content">
            <div className="progress-description-text">{t(label)}</div>
            <div className="progress-description-icon">
              <VtmnTooltip position="top-left" tooltip={t(tooltipMessage)}>
                <VpIcon {...({ name: 'information', size: 22 } as any)} />
              </VtmnTooltip>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (!hasRealized && !hasForecasted) {
    return (
      <WidgetErrorCard
        testId="progress-element-container-no-data"
        titleKey={t(label)}
        messageKey={t('general.homepage.unavailable')}
      />
    )
  }

  return (
    <>
      <div className="progress-element-container">
        <VpProgressBar
          value={0}
          variant="circular"
          size="small"
          // @ts-expect-error
          valueText={valueText}
          src={src}
          className={className}
        />
        <div className="progress-value-container">
          <div className="vp-subtitle-l progress-value-text-no-data">--</div>
          <div className="vp-body-s progress-description-text">{t(label)}</div>
        </div>
      </div>
      <div className="progress-value-error-message-container">
        <div className="progress-value-error-message-subcontainer">
          <div className="progress-value-error-message-subcontainer-icon">
            <VpIcon {...({ name: 'warning-error', size: 16 } as any)} />
          </div>
          <div className="vp-body-s progress-value-error-message-subcontainer-text">{t(errorMessage)}</div>
        </div>
      </div>
    </>
  )
}

export default CircularProgressBar
